import HttpRequest from '@/lib/request'
//export const backendServer = "http://47.99.66.231"
export const backendServer = "http://service.8jg.top"
export const jwtServerInstance = new HttpRequest(backendServer)
